<h2 mat-dialog-title>{{ isEdit ? 'Edit' : 'Add' }} Branch</h2>

<form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
  <mat-dialog-content>
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" [disabled]="isSaving" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || isSaving">
      <mat-spinner *ngIf="isSaving" diameter="20" class="btn-spinner"></mat-spinner>
      <span *ngIf="!isSaving">{{ isEdit ? 'Save' : 'Create' }}</span>
    </button>
  </mat-dialog-actions>
</form>